export type PortalPublicationStatusType =
  | 'PUBLISHED'
  | 'PENDING'
  | 'PROCESSING'
  | 'UPDATING'
export const PORTAL_PUBLICATION_STATUS: Record<
  PortalPublicationStatusType,
  string
> = {
  PUBLISHED: 'Publicada',
  PENDING: 'Pendiente',
  PROCESSING: 'Pendiente',
  UPDATING: 'Actualizando'
}
